import React from 'react'
import { Link as RouterLink } from "react-router-dom";
import logoWhite from "../../images/logo-white.png";
import ryzeWhite from "../../images/ryze-white.png";
import { Toolbar, Typography } from '@material-ui/core'
import useStyles from './styles'

const Footer = () => {
    const classes = useStyles();

    return (
        <footer className={classes.footerRoot}>
            <Toolbar className={classes.footerContainer} square='true' elevation={0} position='static'>
                <div className={classes.footerSection1}>
                    <Typography variant='h6' className={classes.footerHeader}>Site Map</Typography>
                    <RouterLink color='inherit' className={classes.footerLink} to='/'>Home</RouterLink>
                    <RouterLink color='inherit' className={classes.footerLink} to='/courses/search'>Course Search</RouterLink>
                    <RouterLink color='inherit' className={classes.footerLink} to='/courses'>Course Directory</RouterLink>
                    <RouterLink color='inherit' className={classes.footerLink} to='/leaderboard'>Leaderboard</RouterLink>
                    <RouterLink color='inherit' className={classes.footerLink} to='/courses/add'>Add Course</RouterLink>
                    <RouterLink color='inherit' className={classes.footerLink} to='/golf-tips'>Golf Tips</RouterLink>
                    <RouterLink color='inherit' className={classes.footerLink} to='/posts'>Posts</RouterLink>
                </div>
                <div className={classes.footerSection2}>
                    <RouterLink to="/" className={classes.imageContainer}>
                        <img
                            style={{ marginRight: '10px' }}
                            src={logoWhite}
                            alt="Ryze"
                            width="51"
                            height="50"
                        />
                        <img
                            className={classes.title}
                            src={ryzeWhite}
                            alt="Ryze"
                            width="75"
                            height="25"
                        />
                    </RouterLink>
                    <Typography className={classes.footerTagline}>
                        Course data, honest analysis, and tools for real golfers.
                    </Typography>
                </div>
                <div className={classes.footerSection1}>
                    <Typography variant='h6' className={classes.footerHeader}>More</Typography>
                    <RouterLink color='inherit' className={classes.footerLink} to='/handicap-calculator'>Handicap Calculator</RouterLink>
                    <RouterLink color='inherit' className={classes.footerLink} to='/glossary'>Golf Glossary</RouterLink>
                    <RouterLink color='inherit' className={classes.footerLink} to='/about'>About</RouterLink>
                    <RouterLink color='inherit' className={classes.footerLink} to='/contact'>Contact</RouterLink>
                    <RouterLink color='inherit' className={classes.footerLink} to='/api'>API</RouterLink>
                    <RouterLink color='inherit' className={classes.footerLink} to='/privacy-policy'>Privacy Policy</RouterLink>
                    <RouterLink color='inherit' className={classes.footerLink} to='/terms'>Terms of Service</RouterLink>
                </div>
            </Toolbar>
            <div className={classes.footerBottomBar}>
                <Typography variant='body2' className={classes.footerCopyright}>
                    © {new Date().getFullYear()} RYZE Golf. All rights reserved.
                </Typography>
            </div>
        </footer>
    )
}

export default Footer